module.exports = __webpack_public_path__ + "img/vir_device.b574c9d9.jpg";